import superagent from 'superagent';
import getCookie from './getCookie';

const webserviceAdmin = process.env.REACT_APP_WEBSERVICE_ADMIN_CARTMX;

export default async function getAdminCarritoMX({ tmbservice, jsonBody }) {
  const url = `${webserviceAdmin}/${tmbservice}`;
  let response = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TokenNvoAdminMX'), { type: 'bearer' })
    .query(jsonBody)
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
        typeMessage: 'error',
        message: 'Error',
      };
      response = resp;
    });

  return response;
}
